import React, { useState } from "react";
import api from "../../Services/api";
import "./index.css";
import secureLocalStorage from "react-secure-storage";

export class InputCustTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: []
        };
    }

    componentDidMount() {
        this.getData();


    }

    getData() {

        if (secureLocalStorage.getItem('pcf') !== null) {

            const campos = secureLocalStorage.getItem('pcf');

            this.setState({
                tableData: campos
            });
            this.props.incluirDadosCamposCust(campos)
        }

    }

    renderRow(row, i) {
        return <div key={i}>{row}</div>
    }


    render() {

        let rows = []
        let I = 0;
        let J = 0;
        let k = 0;

        for (I = 0; I < this.state.tableData.length; I = I + 2) {

            for (J = I, k = 1; J < this.state.tableData.length; J++, k++) {
                if (J < I + 2) {
                    let groupDescription;
                    if (!this.state.tableData[J].tcv_value) {
                        groupDescription = ""
                    } else {
                        groupDescription = this.state.tableData[J].tcv_value
                    }
                    rows.push(
                        <div id={`content${k}`}>
                            <div id="input-box-ativos-cust1">
                                <span className="details">{this.state.tableData[J].tcf_description}</span>
                                <input
                                    autoComplete="off"
                                    id='${this.state.tableData[J].tcf_alternativeidentifier}'
                                    name={this.state.tableData[J].tcf_alternativeidentifier}
                                    onChange={(e) => onChangeInput(e)}
                                    value={groupDescription}
                                />
                            </div>
                        </div>
                    )

                }
            }

        }


        const onChangeInput = (e, campoId) => {

            const { name, value } = e.target

            const editData = this.state.tableData.map((item) =>
                item.tcf_alternativeidentifier === name && name ? { ...item, tcv_value: value } : item
            )

            this.setState({
                tableData: editData
            });

            this.props.incluirDadosCamposCust(editData)
        }

        return (
            <div id="container-cad-cust1">
                {rows.map((tdata, i) => (
                    this.renderRow(tdata, i)
                ))}
            </div>
        )
    }
}

export default InputCustTask;